module.exports = __webpack_public_path__ + "img/tc1.60dd1fa4.png";